import React, { useState } from 'react'
import { Plus, X } from '@phosphor-icons/react'
import { toast } from '../utils'
const ContentForm = ({ project, content }) => {
  const [formData, setFormData] = useState({
    title: content?.title || '',
    body: content?.body || '',
  })
  const [errors, setErrors] = useState({
    title: [],
    body: [],
  })

  const isValid = formData.title.length >= 5 && formData.body.length >= 100
  const titleError = formData.title.length < 5
    ? 'Title must be at least 5 characters'
    : ''
  const bodyError = formData.body.length < 100
    ? 'Content must be at least 100 characters'
    : ''

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      const response = await fetch(`/projects/${project.id}/contents`, {
        method: 'POST',
        body: JSON.stringify(formData),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').
            getAttribute('content'),
        },
      })
      const data = await response.json()
      if (response.ok) {
        toast({message: 'Content created successfully', type: 'success', duration: 3000, gravity: 'top', position: 'right', close: true})
        Turbo.visit(`/projects/${project.id}/contents/${data.content.id}`)
      } else {
        setErrors(data.content.errors)
      }
    } catch (error) {
      setErrors({
        title: ['Title must be at least 5 characters'],
        body: ['Content must be at least 100 characters'],
      })
      console.error('Error:', error)
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }))

    setErrors(prev => ({
      ...prev,
      [name]: name === 'title' && value.length < 5
        ? ['Title must be at least 5 characters']
        :
        name === 'body' && value.length < 100
          ? ['Content must be at least 100 characters']
          : [],
    }))
  }

  return (
    <form onSubmit={handleSubmit} className="max-w-2xl mx-auto p-6 space-y-2">
      <div className="flex flex-col gap-4">
        <div className="form-control w-full">
          <label className="label font-medium">Title ({formData.title.length}/5
            characters)</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            className={`input input-bordered w-full ${formData.title.length <
            5 || errors.title.length > 0 ? 'input-error' : ''}`}
            placeholder="Enter a descriptive title (minimum 5 characters)"
          />
          {(titleError || errors.title.length > 0) && (
            <div className="label">
              <span className="label-text-alt text-error">
                {titleError || errors.title.join(', ')}
              </span>
            </div>
          )}
        </div>

        <div className="form-control w-full">
          <label className="label font-medium">Body ({formData.body.length}/100
            characters)</label>
          <textarea
            name="body"
            value={formData.body}
            onChange={handleChange}
            className={`textarea textarea-bordered w-full min-h-[300px] ${formData.body.length <
            100 || errors.body.length > 0 ? 'textarea-error' : ''}`}
            placeholder="Enter your content here (minimum 100 characters)..."
          />
          {(bodyError || errors.body.length > 0) && (
            <div className="label">
              <span className="label-text-alt text-error">
                {bodyError || errors.body.join(', ')}
              </span>
            </div>
          )}
        </div>
      </div>

      <div className="flex justify-end gap-2">
        <button
          disabled={!isValid}
          type="submit"
          className="btn btn-primary btn-outline btn-xs"
        >
          <div className="flex gap-2 items-center">
            <Plus size={14}/>
            <span className="text-xs">Create</span>
          </div>
        </button>

        <a href={`/projects/${project.id}`}
           className="btn btn-secondary btn-outline btn-xs">
          <div className="flex gap-2 items-center">
            <X size={14}/>
            <span className="text-xs">Cancel</span>
          </div>
        </a>
      </div>
    </form>
  )
}

export default ContentForm